import RegulationsLayout from '../layouts/RegulationsLayout.vue';

const PrivacyPolicy = () => import('../views/Regulations/PrivacyPolicy.vue');
const Regulation = () => import('../views/Regulations/Regulation.vue');
const MonitorSystemProgress = () => import('../views/Regulations/MonitorSystemProgress.vue');

export default {
  path: '/dokumenty',
  component: RegulationsLayout,
  children: [
    {
      path: 'polityka',
      name: 'Regulations.PrivacyPolicy',
      component: PrivacyPolicy,
      meta: {
        unauthorized: true,
        background: 'white',
        eggos: 'grey',
      },
    },
    {
      path: 'regulamin',
      name: 'Regulations.Regulation',
      component: Regulation,
      meta: {
        unauthorized: true,
        background: 'white',
        eggos: 'grey',
      },
    },
    {
      path: 'system-monitorowania-postepow',
      name: 'Regulations.MonitorSystemProgress',
      component: MonitorSystemProgress,
      meta: {
        unauthorized: false,
        background: 'white',
      },
    },
  ],
};
